module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "container",
    attrs: {
      "id": "todolist"
    }
  }, [_h('div', {
    staticClass: "form_main"
  }, [_h('div', [_h('div', {
    staticClass: "btn-group m_t_m typeBtn",
    attrs: {
      "role": "group"
    }
  }, [_h('button', {
    staticClass: "btn btn-default",
    class: {
      'btn-success': _vm.isActive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAllLists
    }
  }, ["全部"]), " ", _vm._l((_vm.typeLists), function(typeList, index) {
    return _h('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-success': _vm.isIndex == index ? true : false
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showCurrList(index)
        }
      }
    }, [_vm._s(typeList)])
  }), " ", _h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddTypeModal
    }
  }, [_h('i', {
    staticClass: "fa fa-plus"
  })]), " "]), " ", _h('span', {
    staticClass: "message"
  }, [_vm._s(_vm.msg)])]), " ", (_vm.showInListType) ? _h('div', [_h('div', {
    staticClass: "model"
  }, [_h('div', {
    staticClass: "modal-dialog"
  }, [_h('div', {
    staticClass: "modal-content"
  }, [_h('div', {
    staticClass: "modal-header"
  }, [_h('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_h('span', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showInListType = false
      }
    }
  }, ["×"])]), " ", _h('h4', {
    staticClass: "modal-title"
  }, ["为新增的分类取个名字"])]), " ", _h('div', {
    staticClass: "modal-body"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newType),
      expression: "newType"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "请输入分类的名称"
    },
    domProps: {
      "value": _vm._s(_vm.newType)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) { return; }
        _vm.addNewType($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newType = $event.target.value
      }
    }
  })]), " ", _h('div', {
    staticClass: "modal-footer"
  }, [_h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showInListType = false
      }
    }
  }, ["取消"]), " ", _h('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewType
    }
  }, ["确定"])])])])])]) : _vm._e(), " ", _h('div', [_h('div', [_h('div', {
    staticClass: "input-group m_t_s m_b_s"
  }, [_h('span', {
    staticClass: "input-group-btn"
  }, [_h('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addItem
    }
  }, ["+"])]), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "添加计划..."
    },
    domProps: {
      "value": _vm._s(_vm.newItem)
    },
    on: {
      "keyup": function($event) {
        if ($event.keyCode !== 13) { return; }
        _vm.addItem($event)
      },
      "focus": _vm.checkLogin,
      "blur": _vm.clearMsg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })])]), " ", _h('div', {
    staticClass: "task-list"
  }, [_h('ul', [_vm._l((_vm.items), function(item, index) {
    return (!item.isfinished) ? _h('li', {
      staticClass: "plan_list",
      class: [{
        finished: item.isfinished
      }, {
        'active': _vm.selectedIndex == index ? true : false
      }],
      on: {
        "dblclick": function($event) {
          _vm.showEdit(item)
        }
      }
    }, [_h('div', {
      staticClass: "labelforlist"
    }, [_h('label', {
      staticClass: "checkboxInput"
    }, [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isfinished),
        expression: "item.isfinished"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.isfinished) ? _vm._i(item.isfinished, null) > -1 : _vm._q(item.isfinished, true)
      },
      on: {
        "click": _vm.toggleFinished,
        "change": function($event) {
          var $$a = item.isfinished,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.isfinished = $$a.concat($$v))
            } else {
              $$i > -1 && (item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.isfinished = $$c
          }
        }
      }
    })]), " ", _h('span', {
      staticClass: "item_plan",
      on: {
        "click": function($event) {
          _vm.addActive(index)
        }
      }
    }, [_vm._s(item.plan)])])]) : _vm._e()
  })])]), " ", _h('div', {
    staticClass: "task-list"
  }, [(!_vm.showFinishedList) ? _h('button', {
    staticClass: "btn btn-success m_t_s",
    on: {
      "click": _vm.toggleFinishedList
    }
  }, ["收起已完成任务"]) : _h('button', {
    staticClass: "btn btn-success m_t_s",
    on: {
      "click": _vm.toggleFinishedList
    }
  }, ["显示已完成任务"]), " ", " ", (!_vm.showFinishedList) ? _h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_h('ul', [_h('li', [(_vm.showDefault()) ? _h('h5', ["暂无完成任务"]) : _h('h5', ["以下为完成任务"]), " "]), " ", _vm._l((_vm.items), function(item, index) {
    return (item.isfinished) ? _h('li', {
      staticClass: "plan_list plan_list_done",
      class: [{
        finished: item.isfinished
      }, {
        'active': _vm.selectedIndex == index ? true : false
      }],
      on: {
        "dblclick": function($event) {
          _vm.showEdit(item)
        }
      }
    }, [_h('div', {
      staticClass: "labelforlist"
    }, [_h('label', {
      staticClass: "checkboxInput"
    }, [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isfinished),
        expression: "item.isfinished"
      }],
      staticClass: "nochecked",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.isfinished) ? _vm._i(item.isfinished, null) > -1 : _vm._q(item.isfinished, true)
      },
      on: {
        "click": _vm.toggleFinished,
        "change": function($event) {
          var $$a = item.isfinished,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (item.isfinished = $$a.concat($$v))
            } else {
              $$i > -1 && (item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.isfinished = $$c
          }
        }
      }
    })]), " ", _h('span', {
      staticClass: "item_plan line-through",
      on: {
        "click": function($event) {
          _vm.addActive(index)
        }
      }
    }, [_vm._s(item.plan)])])]) : _vm._e()
  })])]) : _vm._e()])]), " ", _h('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.isShowEdit) ? _h('div', {
    staticClass: "fixedEdit"
  }, [_h('i', {
    staticClass: "fa fa-angle-double-right arrow",
    on: {
      "click": _vm.hideEdit
    }
  }), " ", _h('i', {
    staticClass: "fa fa-trash delete",
    on: {
      "click": function($event) {
        _vm.showDeleteConfirm = true
      }
    }
  }), " ", _h('div', {
    staticClass: "labelforlist m_t_m editMain clearfix"
  }, [_h('label', {
    staticClass: "checkboxInput float_l"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.isfinished),
      expression: "item.isfinished"
    }],
    class: {
      'nochecked': _vm.item.isfinished
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.item.isfinished) ? _vm._i(_vm.item.isfinished, null) > -1 : _vm._q(_vm.item.isfinished, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.item.isfinished,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.item.isfinished = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.item.isfinished = $$c
        }
      }
    }
  })]), " ", _h('div', {
    staticClass: "col-xs-11"
  }, [_h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.plan),
      expression: "item.plan"
    }],
    staticClass: "form-control editText",
    attrs: {
      "tabindex": "0"
    },
    domProps: {
      "value": _vm._s(_vm.item.plan)
    },
    on: {
      "blur": function($event) {
        _vm.checkEmpty()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.item.plan = $event.target.value
      }
    }
  })]), " ", " "])]) : _vm._e()]), " ", _h('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.isShowEditType) ? _h('div', {
    staticClass: "fixedEdit"
  }, [_h('i', {
    staticClass: "fa fa-angle-double-right arrow",
    on: {
      "click": _vm.hideEditType
    }
  }), " ", _vm._l((_vm.typeLists), function(type, index) {
    return _h('div', {
      staticClass: "m_t_s"
    }, [_h('div', {
      staticClass: "col-xs-11"
    }, [_h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.typeLists[index]),
        expression: "typeLists[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(_vm.typeLists[index])
      },
      on: {
        "blur": function($event) {
          _vm.checkEmptyType(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.typeLists,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.typeLists[index] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]), " ", _h('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          _vm.showEditTypeConfirm = true
        }
      }
    })])
  })]) : _vm._e()]), " ", (_vm.showDeleteConfirm) ? _h('div', [_h('div', {
    staticClass: "model text-center"
  }, [_h('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_h('div', {
    staticClass: "modal-content"
  }, [_h('div', {
    staticClass: "modal-header"
  }, [_h('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_h('span', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showInListType = false
      }
    }
  }, ["×"])]), " ", _h('h4', {
    staticClass: "modal-title"
  }, ["确定删除吗"])]), " ", _h('div', {
    staticClass: "modal-body"
  }, [_h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteConfirm = false
      }
    }
  }, ["取消"]), " ", _h('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteList
    }
  }, ["确定"])])])])])]) : _vm._e(), " ", (_vm.showEditTypeConfirm) ? _h('div', [_h('div', {
    staticClass: "model text-center"
  }, [_h('div', {
    staticClass: "modal-dialog"
  }, [_h('div', {
    staticClass: "modal-content"
  }, [_h('div', {
    staticClass: "modal-header"
  }, [_h('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_h('span', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showInListType = false
      }
    }
  }, ["×"])]), " ", _h('h4', {
    staticClass: "modal-title"
  }, ["确定删除该分类吗"])]), " ", _h('div', {
    staticClass: "modal-body"
  }, [_h('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteTypePlan
    }
  }, ["删除该类及该类下的计划"]), " ", _h('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteType
    }
  }, ["只删除该类，不删除该类下的计划"]), " ", _h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditTypeConfirm = false
      }
    }
  }, ["取消删除"])])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95ccc170!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todolist.vue
// module id = 44
// module chunks = 1